import * as React from "react";

import * as GuideStateApi from "./guide-state-api.ts";

/**
 * A React context that provides access to the guide state.
 *
 * Please do not use this directly. Instead use the GuideStateProvider and
 * the useGuideState hook.
 */
export const GuideStateApiContext: React.Context<typeof GuideStateApi> =
    React.createContext(GuideStateApi);
GuideStateApiContext.displayName = "GuideStateContext";
